export default __webpack_public_path__ + "static/media/bbb-logo.cc6e67fa.png";